// src/app/components/shared/tab-panel.tsx
//
// -- Migrated onto the kit, Phase 6 ------------------------------------------
//
// The one thing shadcn's Tabs gave the product that Kit 02 item 46 does not:
// a CONTEXT, so `<TabsContent value="x">` could decide for itself whether to
// render without the page threading the selected value through.
//
// Item 46 is a tablist and nothing else, which is right — a tab strip and the
// panel below it are separate concerns, and the kit's is the strip. This is
// the panel half, and it is eleven lines rather than a component library.
//
// The panel is REMOVED from the DOM when it is not selected rather than
// hidden. A hidden panel is still focusable content in the accessibility tree
// unless every implementation remembers `inert`, and this way there is nothing
// to remember.
import { createContext, useContext, type ReactNode } from "react";

const TabValue = createContext<string | null>(null);

export function TabScope({ value, children }: { value: string; children: ReactNode }) {
  return <TabValue.Provider value={value}>{children}</TabValue.Provider>;
}

export function TabPanel({
  value, children, className,
}: { value: string; children: ReactNode; className?: string }) {
  const active = useContext(TabValue);
  if (active !== value) return null;
  return (
    <div role="tabpanel" className={className} data-panel={value}>
      {children}
    </div>
  );
}
